import { usePodStore } from '@/stores/PodStore.js'
import { useNodeStore } from '@/stores/NodeStore.js';

export default {
  methods: {
    onDragStart(event, item) {
      const movingNodes = [];
      const movingPods = [];

      const isPod = item.nodeid !== undefined;

      const shouldMoveAllSelected = isPod && this.selectedPodsIds.includes(item.id) ||
        !isPod && this.selectedNodesIds.includes(item.id);

      if (shouldMoveAllSelected) {
        movingPods.push(...this.selectedPodsIds);
        movingNodes.push(...this.selectedNodesIds);
      } else {
        // Move only the dragged item
        if (isPod) {
          movingPods.push(item.id);
        } else {
          movingNodes.push(item.id);
        }
      }

      event.dataTransfer.setData('text/x-tw-movable-item', true);
      event.dataTransfer.setData('text/x-tw-movable-pods', JSON.stringify(movingPods));
      event.dataTransfer.setData('text/x-tw-movable-nodes', JSON.stringify(movingNodes));
      event.dataTransfer.effectAllowed = 'move';
    },
    onDragEnd(event, item) {
      event; item;
      // For testing purposes
      // console.log("On drag end", event, item);
    },
    isDraggableItem(item, asSearchResult=false) {
      // if (this.$route?.path === '/search') {
      if (asSearchResult) {
        return false;
      }

      if (item.deletedat) {
        return false;
      }
      return true;
    },
  },
  computed: {
    selectedPodsIds() {
      const podStore = usePodStore();
      let selectedPods = podStore.getSelectedPods;
      return selectedPods.map(pod => pod.id);
    },
    selectedNodesIds() {
      const nodeStore = useNodeStore();
      const selectedNodes = nodeStore.getSelectedNodes;

      return selectedNodes.map(node => node.id);
    },
  },
}
